import { render, staticRenderFns } from "./failed-buy.vue?vue&type=template&id=53a5377f&scoped=true"
import script from "./failed-buy.vue?vue&type=script&lang=js"
export * from "./failed-buy.vue?vue&type=script&lang=js"
import style0 from "./failed-buy.vue?vue&type=style&index=0&id=53a5377f&prod&scoped=true&lang=css"
import style1 from "./failed-buy.vue?vue&type=style&index=1&id=53a5377f&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5377f",
  null
  
)

export default component.exports